import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import SpeciesAssignModal from './components/SpeciesAssignModal';
import { hasIdentificationTagAtCreation } from './utils/taxonGroups';
export default function addSpeciesComposer() {
  // DiscussionComposer is code-split (not eagerly registered), same as
  // flarum/tags' addTagComposer.js - extend() has to target it by string
  // path so the callback attaches once it's actually loaded. No
  // canAssignSpecies() permission check here: a brand new discussion has
  // no author yet distinct from the actor creating it, so anyone who can
  // start a discussion can pick its species.
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const tags = this.composer.fields.tags || [];
    if (!hasIdentificationTagAtCreation(tags)) return;
    const count = (this.composer.fields.species || []).length;
    items.add('species', m(Button, {
      icon: "fas fa-dna",
      onclick: () => app.modal.show(SpeciesAssignModal, {
        tags,
        initialEntries: this.composer.fields.species || [],
        onsubmit: entries => {
          this.composer.fields.species = entries;
        }
      })
    }, app.translator.trans('champis-species.forum.assign_species.control_button'), count > 0 ? ` (${count})` : ''));
  });
  extend('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    // data() returns a flat {title, content, ...} object passed straight to
    // Model.save() as its attributes map (see DiscussionComposer.js) - no
    // nested .attributes wrapper, same level as title/content.
    if (this.composer.fields.species && this.composer.fields.species.length) {
      data.species = this.composer.fields.species;
    }
  });
}